module.exports = __webpack_public_path__ + "img/aftersale-01.1a1cd68e.jpg";